var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template-with-block",class:_vm.device.isMobile ? 'template-with-block-mobile' : '',style:({
    fontFamily: _vm.content.templateStyle.fontFamily || '',

    fontSize: _vm.content.templateStyle.fontSize + 'rem' || '',
    lineHeight: _vm.content.templateStyle.lineHeight + 'rem' || '',
    textIndent:
      _vm.content.templateStyle.textIndent &&
      typeof _vm.content.templateStyle.textIndent === 'string'
        ? _vm.content.templateStyle.textIndent
        : _vm.content.templateStyle.textIndent &&
          typeof _vm.content.templateStyle.textIndent === 'number'
        ? _vm.content.templateStyle.textIndent + 'rem'
        : '',
    fontWeight: _vm.content.templateStyle.fontWeight || '',
    textDecoration: _vm.content.templateStyle.underline === 1 ? 'underline' : '',
    fontStyle: _vm.content.templateStyle.fontItalic === 1 ? 'italic' : '',
    textAlign: _vm.content.templateStyle.textAlign || '',
    color: _vm.content.templateStyle.color || '',
    backgroundColor: _vm.content.templateStyle.backgroundColor || '',
    backgroundImage: _vm.content.templateStyle.backgroundImage ? ("url(" + (_vm.content.templateStyle.backgroundImage) + ")") : '',
    backgroundPosition: _vm.content.templateStyle.backgroundPosition || '',
    backgroundSize: _vm.content.templateStyle.backgroundSize || '',
    marginTop:
      (typeof _vm.content.templateStyle.marginTop === 'number' &&
        _vm.content.templateStyle.marginTop + 'rem') ||
      '',
    marginBottom:
      (typeof _vm.content.templateStyle.marginBottom === 'number' &&
        _vm.content.templateStyle.marginBottom + 'rem') ||
      '',
    width: (typeof _vm.content.templateStyle.width === 'string') ? _vm.content.templateStyle.width :
      (typeof _vm.content.templateStyle.width === 'number') ? (_vm.content.templateStyle.width + 'rem') : '',
    padding:
      (typeof _vm.content.templateStyle.padding === 'number' &&
        _vm.content.templateStyle.padding + 'rem') ||
      '',
    paddingTop:
      (typeof _vm.content.templateStyle.paddingTop === 'number' &&
        _vm.content.templateStyle.paddingTop + 'rem') ||
      '',
    paddingBottom:
      (typeof _vm.content.templateStyle.paddingBottom === 'number' &&
        _vm.content.templateStyle.paddingBottom + 'rem') ||
      '',
    borderRadius:
      (typeof _vm.content.templateStyle.borderRadius === 'number' &&
        _vm.content.templateStyle.borderRadius + 'rem') ||
      '',
    border: _vm.content.templateStyle.border || '',
    borderTop: _vm.content.templateStyle.borderTop || '',
    borderBottom: _vm.content.templateStyle.borderBottom || '',
    borderLeft: _vm.content.templateStyle.borderLeft || '',
    borderRight: _vm.content.templateStyle.borderRight || '',
    borderColor:_vm.content.showReset==2?'rgb(240, 248, 245)':''
  }),attrs:{"id":_vm.content.key}},[(_vm.content.showReset === 1)?_c('div',{staticClass:"reset",style:({
      top:
        (typeof _vm.content.resetTop === 'number' && _vm.content.resetTop + 'rem') ||
        '',
      right:
        (typeof _vm.content.resetRight === 'number' &&
          _vm.content.resetRight + 'rem') ||
        '',
    }),on:{"click":function($event){$event.stopPropagation();return _vm.reset($event)}}}):_vm._e(),(_vm.content.showReset === 2)?_c('el-rate',{staticClass:"rate",attrs:{"colors":_vm.colors},model:{value:(_vm.content.rateValue),callback:function ($$v) {_vm.$set(_vm.content, "rateValue", $$v)},expression:"content.rateValue"}}):_vm._e(),(_vm.content.templateType)?_c('img',{staticClass:"evaluation_icon",attrs:{"src":require('@/assets/images/books/book2/evaluation_icon.png'),"alt":""}}):_vm._e(),(_vm.content.templateType)?_c('div',{staticClass:"evaluation_title"},[_vm._v("\n    My Self-Assessment Report\n  ")]):_vm._e(),(_vm.content.templateType)?_c('div',{staticClass:"input_box"},[_vm._m(0),_vm._m(1)]):_vm._e(),(_vm.content.showReset==3)?_c('div',[_vm._v("\n    "+_vm._s(_vm.content[0].contentList)+"\n  ")]):_vm._e(),_c('commonIndex',{attrs:{"bookContent":_vm.content.content}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("Student: "),_c('span',{attrs:{"contenteditable":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("Date: "),_c('span',{attrs:{"contenteditable":""}})])}]

export { render, staticRenderFns }